import { MapPin, Search, Truck, X } from "lucide-react";

import { TruckListDatePicker } from "./TruckListDatePicker";
import { TruckListSelect } from "./TruckListSelect";

const formatSearchLocation = ({ city, state, zip }) => `${[city, state].filter(Boolean).join(", ")} ${zip}`.trim();

// Toolbar shown above the table: truck count, location search and the
// dispatcher / equipment / ready-date filter dropdowns. When the search names a
// place, the place the distances are measured from is shown under the search box.
export const TruckListToolbar = ({
    count,
    loading,
    locationQuery,
    onLocationChange,
    searchLocation,
    dispatcher,
    dispatcherItems,
    onDispatcherChange,
    equipment,
    equipmentItems,
    onEquipmentChange,
    readyDate,
    onReadyDateChange,
    onClearAll,
}) => (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-cm-p-outline bg-cm-p-surface px-5 py-3">
        <div className="flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded bg-cm-p-accent-50">
                <Truck className="h-4 w-4 text-cm-p-accent-800" />
            </div>
            <span className="text-[20px] font-medium text-cm-p-text-primary">
                {loading ? "Trucks" : `${count} ${count === 1 ? "truck" : "trucks"}`}
            </span>
        </div>

        <div className="flex max-w-full flex-col items-start gap-1">
            <div className="flex max-w-full flex-wrap items-center gap-3">
                <div className="flex h-10 w-[344px] max-w-full items-center gap-2 rounded-[36px] border border-cm-p-outline bg-cm-p-surface-container px-3">
                    <Search className="h-4 w-4 shrink-0 text-cm-p-text-secondary" />
                    <input
                        value={locationQuery}
                        onChange={(event) => onLocationChange(event.target.value)}
                        placeholder="Enter location to find closest trucks"
                        // `border-0` strips the default border that `@tailwindcss/forms` adds to every
                        // input — the parent pill already carries the visible border. `focus:!ring-0`
                        // suppresses the green focus ring the forms plugin also applies on focus.
                        className="w-full border-0 bg-transparent text-[15px] font-medium text-cm-p-text-primary outline-none placeholder:font-normal placeholder:text-cm-p-text-secondary focus:!ring-0"
                    />
                    {locationQuery && (
                        <button
                            type="button"
                            onClick={() => onLocationChange("")}
                            className="shrink-0 text-cm-p-text-secondary hover:text-cm-p-text-primary"
                            aria-label="Clear location"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    )}
                </div>

                <TruckListSelect items={dispatcherItems} value={dispatcher} onChange={onDispatcherChange} placeholder="Dispatcher" />
                <TruckListSelect items={equipmentItems} value={equipment} onChange={onEquipmentChange} placeholder="Equipment" />
                <TruckListDatePicker value={readyDate} onChange={onReadyDateChange} />

                <button
                    type="button"
                    onClick={onClearAll}
                    className="px-2 py-1.5 text-sm font-medium text-cm-p-text-secondary hover:text-cm-p-text-primary"
                >
                    Clear all
                </button>
            </div>

            {searchLocation && (
                <span className="flex max-w-[344px] items-center gap-1 px-3 text-xs text-cm-p-text-secondary">
                    <MapPin className="h-3 w-3 shrink-0" />
                    <span className="truncate">Distance from {formatSearchLocation(searchLocation)}</span>
                </span>
            )}
        </div>
    </div>
);
